"use client";
import { IBlocks } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import LoadingSkeleton from "@/components/admin/profile/blocks/LoadingSkeleton";
import { IconBrandYoutube } from "@tabler/icons-react";
import { Label } from "@/components/ui/label";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockYoutubeVideoLatest({
    edit,
    block,
    update,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Latest Video - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div className="relative aspect-video w-full min-w-full">
                <div className={`w-full min-w-full`}>
                    <div
                        className={`absolute flex w-full min-w-full place-content-center items-center justify-center`}
                    >
                        <LoadingSkeleton
                            nopulse
                            className="bg-user-primary-color"
                        />
                        <div className="absolute flex flex-col items-center">
                            <IconBrandYoutube
                                className="z-50 rounded-md bg-red-500 p-1 shadow-xl"
                                size={40}
                            />
                            <Label
                                className="text-user-primary-text-color"
                                variant="headingtoggle"
                            >
                                (Preview latest video)
                            </Label>
                        </div>
                    </div>
                </div>
            </div>
        </AdminPopover>
    );
}
